/*
 * APL cart rewards
 * Keeps the free reward items in the cart in sync with the order total:
 *  - Free Shipping item: in the cart whenever there is at least one paid item
 *  - Free Gift Bundle:   in the cart when paid items total >= the gift threshold
 *  - Old reward products (e.g. the previous "Free Gift") are removed
 * Runs on page load and after every cart add / change / update / clear.
 * Settings come from the JSON in snippets/ajax-cart.liquid.
 */
(function () {
  if (window.APLCartRewards) return;

  var configEl = document.getElementById('apl-cart-rewards-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var MARK = 'X-APL-Rewards';
  var rewardHandles = [config.ship.handle, config.gift.handle].concat(config.retired || []);
  var busy = false;
  var again = false;
  var timer = null;
  var nativeFetch = window.fetch.bind(window);

  function isReward(item) {
    return item && item.handle && rewardHandles.indexOf(item.handle) !== -1;
  }

  function request(url, body) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[MARK] = '1';
    return nativeFetch(url, {
      method: body ? 'POST' : 'GET',
      headers: headers,
      credentials: 'same-origin',
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshViews() {
    if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart && typeof Shopify.theme.jsAjaxCart.updateView === 'function') {
      Shopify.theme.jsAjaxCart.updateView();
    }
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  function sync() {
    if (busy) {
      again = true;
      return;
    }
    busy = true;

    request('/cart.js')
      .then(function (cart) {
        var paidTotal = 0;
        var paidCount = 0;
        var lines = {};

        (cart.items || []).forEach(function (item) {
          if (isReward(item)) {
            lines[item.handle] = lines[item.handle] || [];
            lines[item.handle].push(item);
          } else {
            paidTotal += item.final_line_price;
            paidCount += item.quantity;
          }
        });

        var want = {};
        want[config.ship.handle] = config.ship.variant && paidCount > 0 ? 1 : 0;
        want[config.gift.handle] = config.gift.variant && paidCount > 0 && paidTotal >= config.gift.threshold ? 1 : 0;
        (config.retired || []).forEach(function (handle) {
          want[handle] = 0;
        });

        var variantFor = {};
        variantFor[config.ship.handle] = config.ship.variant;
        variantFor[config.gift.handle] = config.gift.variant;

        // Fix existing lines (wrong quantity, duplicates, retired products)
        var updates = {};
        var changed = false;
        Object.keys(lines).forEach(function (handle) {
          var target = want[handle] || 0;
          lines[handle].forEach(function (line, index) {
            var qty = index === 0 ? target : 0;
            if (line.quantity !== qty) {
              updates[line.key] = qty;
              changed = true;
            }
          });
        });

        // Add rewards that are missing (by variant id; update.js adds new lines)
        var adds = {};
        var needsAdd = false;
        [config.ship.handle, config.gift.handle].forEach(function (handle) {
          if (want[handle] > 0 && !lines[handle] && variantFor[handle]) {
            adds[variantFor[handle]] = 1;
            needsAdd = true;
          }
        });

        var chain = Promise.resolve();
        if (changed) {
          chain = chain.then(function () {
            return request('/cart/update.js', { updates: updates });
          });
        }
        if (needsAdd) {
          chain = chain.then(function () {
            return request('/cart/update.js', { updates: adds });
          });
        }
        return chain.then(function () {
          if (changed || needsAdd) refreshViews();
          // Header count shows only the items the customer picked
          var setCount = function () {
            document.querySelectorAll('.aplCartHeader__count').forEach(function (el) {
              el.textContent = paidCount;
            });
          };
          setCount();
          setTimeout(setCount, 700);
          setTimeout(setCount, 1500);
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          schedule();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  function isCartWrite(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
  }

  function hasMark(init) {
    if (!init || !init.headers) return false;
    var h = init.headers;
    if (typeof h.get === 'function') return h.get(MARK) === '1';
    return h[MARK] === '1';
  }

  // Watch the store's own cart requests (fetch + XHR)
  var wrappedFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var mine = hasMark(init);
    return wrappedFetch.apply(this, arguments).then(function (response) {
      if (!mine && isCartWrite(url)) schedule();
      return response;
    });
  };

  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) {
      this.addEventListener('load', schedule);
    }
    return open.apply(this, arguments);
  };

  // Plain form posts to /cart/add reload the page, so check once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.APLCartRewards = { sync: sync };
})();
